import { Spinner } from '@/components/ui/spinner';

export const VideoDisabledView = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
    <div
      className="w-32 h-32 rounded-full bg-slate-700 flex items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-400"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </div>
  </div>
);

export const VideoHiddenView = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
    <div className="text-center">
      <div
        className="w-32 h-32 rounded-full bg-slate-700 flex items-center justify-center mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-400"
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <path d="m1 1 22 22"/>
          <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"/>
        </svg>
      </div>
      <p className="text-gray-400 text-sm">Video hidden locally</p>
    </div>
  </div>
);

export const VideoConnectingView = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
    <div className="text-center">
      <div className="mb-4">
        <Spinner
          size="large"
          variant="primary"
          text="Connecting..."
        />
      </div>
    </div>
  </div>
);

export const ClickStartSessionView = () => (
  <div className="absolute inset-0 w-full h-full bg-gray-900 flex items-center justify-center">
    <div className="text-center">
      <div className="space-y-4">
        <div className="text-4xl text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto mb-2"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 7 L6 7 15 16 M1 1 L23 1 23 23 1 23 1 1"/>
          </svg>
        </div>
        <p className="text-xl font-semibold text-gray-300">Click &quot;Start Session&quot; to begin</p>
        <p className="text-gray-500 max-w-md">Connect with people from around the world</p>
      </div>
    </div>
  </div>
);

export const SmallConnectingView = () => (
  <div className="absolute inset-0 bg-gray-900 flex items-center justify-center">
    <Spinner size="small" variant="primary"/>
  </div>
);

export const SmallStartSessionView = () => (
  <div className="absolute inset-0 bg-gray-900 flex items-center justify-center">
    <div className="text-center p-2">
      <p className="text-sm text-gray-400">Start session</p>
    </div>
  </div>
);
